import { DisplayInfo } from 'components/displayInfo/displayInfo';
import { ModalService } from 'services/modal.service';

import template from './displayShippingMethod.html';
import './displayShippingMethod.scss';

export const DisplayShippingMethod = angular
    .module('checkout.components.displayShippingMethod', [
        DisplayInfo,
        ModalService
    ]).component('displayShippingMethod', {
        template,
        bindings: {
            shippingMethod: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/displayShippingMethod/displayShippingMethod.js